export const getLanguageName = (code) => {
  if (code) {
    let languageName = new Intl.DisplayNames(['en'], { type: 'language', style: 'short' }).of(code);
    return languageName;
  }
  l;
};
